import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import styles from './EmailSummary.css'

import Heading from '../Heading'
import InputText from '@healthwise-ui/core/InputText'
import Textarea from '@healthwise-ui/core/TextArea'
import Button from '@healthwise-ui/core/Button'
import LoadingIndicator from '@healthwise-ui/core/LoadingIndicator'

import { SUMMARY_EMAIL_STATUS__LOADING } from '../../actions/'

class EmailSummary extends Component {
  constructor(props) {
    super(props)

    this.validateEmailFields = this.validateEmailFields.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onOkay = this.onOkay.bind(this)
    this.onSend = this.onSend.bind(this)
    this.resetState = this.resetState.bind(this)

    this.state = {
      email1: '',
      email2: '',
      showError: false,
      showButtonShake: false
    }
  }

  componentDidUpdate() {
    // if there's an error sending the email, scroll to the top, to ensure the error is seen
    if (this.props.emailSuccess === false) {
      document.getElementsByClassName('ReactModal__Content')[0].scrollTop = 0
    } else if (this.props.emailSuccess === true) {
      ReactDOM.findDOMNode(this.refs.okayButton).focus()
    }
  }

  // returns boolean for validity
  validateEmailFields() {
    const email1isValid = this.email1Validator()
    const email2isValid = this.email2Validator()
    const isValid = email1isValid && email2isValid

    this.setState({
      showError: !isValid,
      showButtonShake: !isValid
    })

    return isValid
  }

  getStatusText(status) {
    switch (status) {
      case true:
        return 'Success! Your email has been sent.'
      case false:
        return 'Error! Something went wrong. Try again.'
      default:
        return ''
    }
  }

  getStatus(status) {
    var statusText = this.getStatusText(status)
    switch (status) {
      case true:
        return <div className={styles.statusSuccess}>{statusText}</div>
      case false:
        return <div className={styles.statusError}>{statusText}</div>
      default:
        return null
    }
  }

  onChange(e, whichEmail) {
    const obj = {}
    obj[whichEmail] = e.target.value
    // clear the error on any change
    obj.showError = false
    obj.blankinlineError = false
    obj.showSuccess = false

    this.setState(obj)
  }

  onOkay() {
    this.props.setEmailStatus(null)
    this.props.onOkay()
  }

  onSend() {
    // validate form before sending
    if (this.validateEmailFields()) {
      let { responses, esdpMap } = this.props
      let json = {}
      json.recipientName = this.recipientName
      json.to = this.state.email1
      json.subject = 'Decision Summary - ' + esdpMap.title.consumer
      json.optionalMessage = this.optionalMessage
      json.responses = responses
      json.questionGroups = esdpMap.topics[4].topics.filter(function(topic) {
        return topic.type === 'hwDecisionAssessment'
      })
      json.checkmarkCID = 'checkmark'
      json.healthwiseLogoCID = 'healthwiseLogo'
      json.resources = [
        {
          name: 'checkmark',
          type: 'image/jpeg',
          content:
            '/9j/4AAQSkZJRgABAQIACwALAAD/2wBDAAUDBAQEAwUEBAQFBQUGBwwIBwcHBw8LCwkMEQ8SEhEPERETFhwXExQaFRERGCEYGh0dHx8fExciJCIeJBweHx7/wAALCAAcABwBAREA/8QAGQAAAwADAAAAAAAAAAAAAAAAAwQGAgUI/8QAKhAAAQQBAwQCAgEFAAAAAAAAAQIDBAUGERIhAAcxQRNRImEUI3FygpP/2gAIAQEAAD8A6fzTJbCJaRMYxiIxNyKa0Xh/IJEeFHB2mQ9t5KdfxSgaFatQCAFKSm12/kygH8gznLLGWeVGLPVXspP0huPt0T/kVn7J6BNrcyw5o2NHb2GWVjI3SKixKFy9g8mM+AkqWPOx3du8BSerKhtq+9pYdxVSEyYUxpLzDgBG5JHsHkH0QeQdQepTtokS8kzi6e/KU9d/wgT5QxHZbShA/W5Tq/7unrE92cHGI32TOWqmYtA+5HsWXmlNyGXUqKQgtK0VuWdNg0/LUfvRbs3FzGcmxzXNJEqJKvShUKiLh+Kqip1+NBT7eUFblq+9Bxpp0rh9sjHb3MqJmM47EjX6nI6Gxw0H40eS4n/q86r/AG6bXLbwbuLPcslBjHspeaealq4bi2IbS0ptw+Eh1DbRSTxvSsHladT5J2mwrIO4dZnNjWlVrAIUUpVo1JWgf0lvI8LU3qdpPI19gACky7I6rFqR22t3y2ykhDbaE7nZDquENNIHK3FHgJHJPWp7X01hX0UqxvWUNXN3Ocs57IUFBhawlKGdffxtIabJHBKCRweqaxhQ7GC9AsIjEuI+gtvMPthbbiT5SpJ4I/R6jUdt2YSfhx/MMtoYg4TEizkPsoH0gSW3ShP0EkAegOnsfwGiqrZF3IcsLq5bSUt2FtKVJdaB8hoH8GgffxpTr716q+v/2Q=='
        },
        {
          name: 'healthwiseLogo',
          type: 'image/png',
          content:
            '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'
        }
      ]

      this.props.onSend(json)

      return true
    } else {
      this.setState({ showButtonShake: true })

      return false
    }
  }

  resetState() {
    setTimeout(() => {
      if (this.state.showButtonShake) {
        this.setState({ showButtonShake: false })
      }
    }, 875)
  }

  render() {
    const status = this.getStatus(this.props.emailSuccess)
    const statusText = this.getStatusText(this.props.emailSuccess)
    const loading =
      this.props.emailSuccess === SUMMARY_EMAIL_STATUS__LOADING ? (
        <div className={styles.loading}>
          <LoadingIndicator style={{ top: '50%', marginTop: '-15px' }} />
        </div>
      ) : null
    let shakeButtonClasses = 'shake'

    const themeOverride = {
      colorBackgroundLight: 'white',
      colorTextPrimary: 'rgb(66, 66, 66)',
      colorTextSecondary: '#676767',
      colorError: '#dd372f',
      focusIndicator: `2px dotted rgb(66, 66, 66)`,
      focusIndicatorOffset: '2px'
    }

    if (this.state.showButtonShake) {
      shakeButtonClasses += ' shake-active'
      // reset "shake" state (after a timeout)
      this.resetState()
    }

    return this.props.emailSuccess === true ? (
      <div className={styles.wrapper}>
        <Heading
          headingLevel={2}
          styleLevel={1}
          id="emailSummary_heading"
          className={styles.heading}
          aria-label={statusText}
        >
          <svg
            className={styles.emailSvg}
            role="presentation"
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 23"
          >
            <g fill="none">
              <path
                d="M2.885 21.77C2.643 21.77 2.416 21.711 2.211 21.613L11.541 12.283 12.635 13.377 19.365 13.377 20.462 12.28 30.102 21.412C29.831 21.633 29.49 21.77 29.115 21.77L2.885 21.77ZM1.311 2.885C1.311 2.643 1.371 2.416 1.469 2.211L10.799 11.541 1.469 20.871C1.371 20.666 1.311 20.439 1.311 20.197L1.311 2.885ZM29.115 1.311C29.357 1.311 29.584 1.371 29.789 1.469L18.93 12.328 13.07 12.328 2.211 1.469C2.416 1.371 2.643 1.311 2.885 1.311L29.115 1.311ZM21.204 11.538L30.531 2.211C30.629 2.416 30.689 2.643 30.689 2.885L30.689 20.197C30.689 20.298 30.677 20.398 30.658 20.495L21.204 11.538ZM29.115 0.262L2.885 0.262C1.439 0.262 0.262 1.439 0.262 2.885L0.262 20.197C0.262 21.643 1.439 22.82 2.885 22.82L29.115 22.82C30.561 22.82 31.738 21.643 31.738 20.197L31.738 2.885C31.738 1.439 30.561 0.262 29.115 0.262L29.115 0.262Z"
                fill="#017acd"
              />
              <path
                d="M2.885 21.77C2.643 21.77 2.416 21.711 2.211 21.613L11.541 12.283 12.635 13.377 19.365 13.377 20.462 12.28 30.102 21.412C29.831 21.633 29.49 21.77 29.115 21.77L2.885 21.77 2.885 21.77ZM1.311 2.885C1.311 2.643 1.371 2.416 1.469 2.211L10.799 11.541 1.469 20.871C1.371 20.666 1.311 20.439 1.311 20.197L1.311 2.885 1.311 2.885ZM29.115 1.311C29.357 1.311 29.584 1.371 29.789 1.469L18.93 12.328 13.07 12.328 2.211 1.469C2.416 1.371 2.643 1.311 2.885 1.311L29.115 1.311 29.115 1.311ZM21.204 11.538L30.531 2.211C30.629 2.416 30.689 2.643 30.689 2.885L30.689 20.197C30.689 20.298 30.677 20.398 30.658 20.495L21.204 11.538 21.204 11.538ZM29.115 0.262L2.885 0.262C1.439 0.262 0.262 1.439 0.262 2.885L0.262 20.197C0.262 21.643 1.439 22.82 2.885 22.82L29.115 22.82C30.561 22.82 31.738 21.643 31.738 20.197L31.738 2.885C31.738 1.439 30.561 0.262 29.115 0.262L29.115 0.262Z"
                stroke="#017acd"
              />
            </g>
          </svg>
          Email Your Decision Summary
        </Heading>

        {status}

        <div className={styles.buttonsWrapper}>
          <Button onClick={this.onOkay} ref="okayButton">
            Okay
          </Button>
        </div>
      </div>
    ) : (
      <div className={styles.wrapper}>
        <Heading
          headingLevel={2}
          styleLevel={1}
          id="emailSummary_heading"
          className={styles.heading}
          aria-label="Email Summary Modal Window (use the cancel button to close)"
        >
          <svg
            className={styles.emailSvg}
            role="presentation"
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 23"
          >
            <g fill="none">
              <path
                d="M2.885 21.77C2.643 21.77 2.416 21.711 2.211 21.613L11.541 12.283 12.635 13.377 19.365 13.377 20.462 12.28 30.102 21.412C29.831 21.633 29.49 21.77 29.115 21.77L2.885 21.77ZM1.311 2.885C1.311 2.643 1.371 2.416 1.469 2.211L10.799 11.541 1.469 20.871C1.371 20.666 1.311 20.439 1.311 20.197L1.311 2.885ZM29.115 1.311C29.357 1.311 29.584 1.371 29.789 1.469L18.93 12.328 13.07 12.328 2.211 1.469C2.416 1.371 2.643 1.311 2.885 1.311L29.115 1.311ZM21.204 11.538L30.531 2.211C30.629 2.416 30.689 2.643 30.689 2.885L30.689 20.197C30.689 20.298 30.677 20.398 30.658 20.495L21.204 11.538ZM29.115 0.262L2.885 0.262C1.439 0.262 0.262 1.439 0.262 2.885L0.262 20.197C0.262 21.643 1.439 22.82 2.885 22.82L29.115 22.82C30.561 22.82 31.738 21.643 31.738 20.197L31.738 2.885C31.738 1.439 30.561 0.262 29.115 0.262L29.115 0.262Z"
                fill="#017acd"
              />
              <path
                d="M2.885 21.77C2.643 21.77 2.416 21.711 2.211 21.613L11.541 12.283 12.635 13.377 19.365 13.377 20.462 12.28 30.102 21.412C29.831 21.633 29.49 21.77 29.115 21.77L2.885 21.77 2.885 21.77ZM1.311 2.885C1.311 2.643 1.371 2.416 1.469 2.211L10.799 11.541 1.469 20.871C1.371 20.666 1.311 20.439 1.311 20.197L1.311 2.885 1.311 2.885ZM29.115 1.311C29.357 1.311 29.584 1.371 29.789 1.469L18.93 12.328 13.07 12.328 2.211 1.469C2.416 1.371 2.643 1.311 2.885 1.311L29.115 1.311 29.115 1.311ZM21.204 11.538L30.531 2.211C30.629 2.416 30.689 2.643 30.689 2.885L30.689 20.197C30.689 20.298 30.677 20.398 30.658 20.495L21.204 11.538 21.204 11.538ZM29.115 0.262L2.885 0.262C1.439 0.262 0.262 1.439 0.262 2.885L0.262 20.197C0.262 21.643 1.439 22.82 2.885 22.82L29.115 22.82C30.561 22.82 31.738 21.643 31.738 20.197L31.738 2.885C31.738 1.439 30.561 0.262 29.115 0.262L29.115 0.262Z"
                stroke="#017acd"
              />
            </g>
          </svg>
          Email Your Decision Summary
        </Heading>

        {status}

        <fieldset className={`hw-compare-box-wrapper`}>
          <InputText
            type="text"
            label="Name of Recipient:"
            autoFocus
            onChange={e => {
              this.recipientName = e.target.value
            }}
            theme={themeOverride}
          />

          <InputText
            type="email"
            label="Recipient's Email Address:"
            required
            onChange={e => {
              this.onChange(e, 'email1')
            }}
            getValidator={validator => (this.email1Validator = validator)}
            theme={themeOverride}
          />

          <InputText
            type="email"
            label="Confirm Email Address:"
            required
            onChange={e => {
              this.onChange(e, 'email2')
            }}
            validators={{
              matching: val => {
                const otherEmail = this.state.email1
                return !!(otherEmail.length && val === otherEmail)
              }
            }}
            validationErrors={{
              matching: 'Emails must match.'
            }}
            getValidator={validator => (this.email2Validator = validator)}
            theme={themeOverride}
          />

          <InputText type="text" label="Your Name:" theme={themeOverride} />

          <Textarea
            label="Your Message to the Recipient:"
            maxCharacters="250"
            onChange={e => {
              this.optionalMessage = e.target.value
            }}
            theme={themeOverride}
          />

          <div className={styles.buttonsWrapper}>
            <span className={shakeButtonClasses}>
              <Button rounded onClick={this.onSend}>
                Send
              </Button>
            </span>
            <Button
              rounded
              className={styles.secondaryButton}
              onClick={this.props.onCancel}
            >
              Cancel
            </Button>
          </div>
        </fieldset>

        <p>
          By selecting "Send," you understand and agree that the decision
          summary and any message you've included for the recipient will be sent
          via unencrypted email to the email address you provided above.
        </p>

        {loading}
      </div>
    )
  }
}

EmailSummary.propTypes = {
  onCancel: PropTypes.func,
  onSend: PropTypes.func,
  onOkay: PropTypes.func,
  esdpMap: PropTypes.object,
  responses: PropTypes.object,
  emailSuccess: PropTypes.any,
  setEmailStatus: PropTypes.func
}

EmailSummary.defaultsProps = {
  onCancel: () => {},
  onSend: () => {},
  onOkay: () => {}
}

export default EmailSummary



// WEBPACK FOOTER //
// /src/~/@healthwise/enhanced-shared-decision-point/components/EmailSummary/index.js